import { IngredientKind } from '@sg/graphql-schema';

import { type Guard, type Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Checks if too few base modifications have been selected in a given context.
 *
 * The function evaluates the number of base modifications against the provided
 * modification limits for the active modification group.
 */
export const checkIfTooFewBasesSelected: Guard = function (args) {
  const { context } = args;

  const { modifications, modificationLimits } = context;

  // ─── Missing Data ────────────────────────────────────────────────────

  const hasMissingData = !modifications;

  if (hasMissingData) {
    return false;
  }

  // ─────────────────────────────────────────────────────────────────────

  const { active } = modifications;

  const baseIngredients = active.filter(checkIfBaseModification);
  const baseIngredientsCount = baseIngredients.reduce(sumQuantity, 0);
  const baseIngredientGroup = baseIngredients[0]?.modificationGroupName;
  const baseModificationLimit = modificationLimits[baseIngredientGroup];

  if (!baseModificationLimit) {
    return false;
  }

  return baseIngredientsCount < baseModificationLimit.maxAggregateQuantity;
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function checkIfBaseModification(modification: Modification) {
  return modification.ingredient?.kind === IngredientKind.Base;
}

function sumQuantity(total: number, modification: Modification) {
  return total + modification.quantity;
}
